import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { type } from '@app/util/util';

import { UpsellResponse } from '@shared/flight-itinerary/entities/upsell-flights';
import { FetchFlightsOptionPayload } from '@flight-results/entities/fetch-flights-option.payload';
import { UpsellPackagePayload } from '@packages/packages-result/entities/upsell';

export const fetchUpsellOptionsAction = createAction(
  type('[Upsell/API] Fetch upsell flights option'),
  props<{ optionId: number, searchId: string, sessionToken: string, isFlightUpsellTreatment?: boolean }>()
);
export const fetchUpsellOptionsBySectorAction = createAction(
  type('[Upsell/API] Fetch upsell flights option by sector'),
  props<{ optionId: number, searchId: string, sessionToken: string, previousOptions: number[] }>()
);
export const fetchUpsellOptionsSuccessAction = createAction(
  type('[Upsell/API] Fetch upsell flights option Success'),
  props<{ upsellOptions: UpsellResponse }>()
);
export const fetchOptionForUpsellAction = createAction(
  type('[Upsell/API] Fetch flights option For Upsell'),
  props<{ payload: FetchFlightsOptionPayload, isFlightUpsellTreatment?: boolean }>()
);
export const fetchUpsellOptionsErrorAction = createAction(
  type('[Upsell/API] Fetch upsell flights option Error'),
  props<{ payload: HttpErrorResponse }>()
);
export const fetchUpsellOptionsForDesktopAction = createAction(
  type('[Upsell/API] Fetch upsell flights option For Desktop'),
  props<{
    optionId: number, searchId: string, 
    sessionToken: string, airlineCode: string, flightKeys: string, isFlightUpsellTreatment?: boolean 
  }>()
);
export const fetchUpsellOptionsForDesktopSuccessAction = createAction(
  type('[Upsell/API] Fetch upsell flights option For Desktop Success'),
  props<{ upsellOptions: UpsellResponse }>()
);
export const fetchUpsellOptionsForDesktopErrorAction = createAction(
  type('[Upsell/API] Fetch upsell flights option For Desktop Error'),
  props<{ payload: HttpErrorResponse }>()
);
export const fetchPackageUpsellOptionsAction = createAction(
  type('[Upsell/PackagesResult/API] Fetch upsell flights option'),
  props<{ payload: UpsellPackagePayload }>()
);
export const fetchPackageUpsellOptionsErrorAction = createAction(
  type('[Upsell/PackagesResult/Data] Fetch upsell flights option error'),
  props<{ payload: HttpErrorResponse }>()
);
export const fetchPackageUpsellOptionsSuccessAction = createAction(
  type('[Upsell/PackagesResult/API] Fetch upsell flights option success'),
  props<{ response: UpsellResponse }>()
);
export const fetchFlightsOptionForPackageUpsellAction = createAction(
  type('[Upsell/PackagesResult/API] Fetch flight option for upsell'),
  props<{ payload: FetchFlightsOptionPayload, upsell: UpsellPackagePayload }>()
);
export const fetchFlightsOptionForPackageUpsellForDesktopAction = createAction(
  type('[Upsell/PackagesResult/API] Fetch flight option for upsell for desktop'),
  props<{ payload: FetchFlightsOptionPayload, upsell: UpsellPackagePayload }>()
);
export const fetchUpsellOptionsForPackageUpsellForDesktopAction = createAction(
  type('[Upsell/PackagesResult] Fetch upsell flights option for package for desktop'),
  props<{ payload: FetchFlightsOptionPayload, upsell: UpsellPackagePayload }>()
);
export const resetUpsellAction = createAction(
  type('[Upsell/API] Reset all upsell')
);
export const fetchUpsellOptionsErrorBySectorAction = createAction(
  type('[Upsell/API] Fetch upsell flights option Error by sector'),
  props<{ payload: HttpErrorResponse }>()
);

export const upsellActions = {
  fetchUpsellOptionsAction,
  fetchUpsellOptionsSuccessAction,
  fetchUpsellOptionsErrorAction,
  fetchUpsellOptionsForDesktopAction,
  fetchUpsellOptionsForDesktopSuccessAction,
  fetchUpsellOptionsForDesktopErrorAction,
  fetchUpsellOptionsForPackageUpsellForDesktopAction
};
